import {
  defaultCabinClass,
  defaultPassengerCounts,
} from "@/constants/passengers";

const tomorrow = new Date();
tomorrow.setDate(tomorrow.getDate() + 1);
tomorrow.setHours(0, 0, 0, 0);

const twoDaysFromNow = new Date();
twoDaysFromNow.setDate(twoDaysFromNow.getDate() + 3);
twoDaysFromNow.setHours(0, 0, 0, 0);

export const initialState = {
  activeTab: 0, // 0: "one-way", 1: "round-trip", 2: "multi-city"
  loading: false,
  initialLoading: false,
  onlyDirectFlights: false,
  departureDate: tomorrow,
  returnDate: twoDaysFromNow,
  departureCity: null,
  returnCity: null,
  passengers: defaultPassengerCounts,
  cabinClass: defaultCabinClass,
  latestFlightSearches: null,
  popularCities: null,
  nearestAirports: null,
  cheapestFlightsMonthly: null,
  cheapestFlightsMonthlyByMonth: null,
  oneWayCalendarPrices: null,
  multiFlights: [
    {
      id: 1,
      departureCity: null,
      arrivalCity: null,
      departureDate: tomorrow,
    },
    {
      id: 2,
      departureCity: null,
      arrivalCity: null,
      departureDate: tomorrow,
    },
  ],
  publicHolidays: [],
};

export const flightSearchReducer = (state = initialState, action) => {
  switch (action.type) {
    case "SET_LOADING":
      return { ...state, loading: action.payload };
    case "SET_INITIAL_LOADING":
      return { ...state, initialLoading: action.payload };
    case "SET_ONLY_DIRECT_FLIGHTS":
      return { ...state, onlyDirectFlights: action.payload };
    case "SET_ACTIVE_TAB":
      return { ...state, activeTab: action.payload };
    case "SET_DEPARTURE_DATE":
      return { ...state, departureDate: action.payload };
    case "SET_RETURN_DATE":
      return { ...state, returnDate: action.payload };
    case "SET_DEPARTURE_CITY":
      return { ...state, departureCity: action.payload };
    case "SET_RETURN_CITY":
      return { ...state, returnCity: action.payload };
    case "TOGGLE_DEPARTURE_AND_RETURN":
      return {
        ...state,
        departureCity: state.returnCity,
        returnCity: state.departureCity,
      };
    case "SET_PASSENGERS":
      return { ...state, passengers: action.payload };
    case "SET_CABIN_CLASS":
      return { ...state, cabinClass: action.payload };
    case "SET_PASSENGERS_AND_CABIN_CLASS":
      return {
        ...state,
        passengers: action.payload.passengers,
        cabinClass: action.payload.cabinClass,
      };
    case "SET_LATEST_FLIGHT_SEARCHES":
      return { ...state, latestFlightSearches: action.payload };
    case "SET_POPULAR_CITIES":
      return { ...state, popularCities: action.payload };
    case "SET_NEAREST_AIRPORTS":
      return { ...state, nearestAirports: action.payload };
    case "SET_CHEAPEST_FLIGHTS_MONTHLY":
      return { ...state, cheapestFlightsMonthly: action.payload };
    case "SET_CHEAPEST_FLIGHTS_MONTHLY_BY_MONTH":
      return { ...state, cheapestFlightsMonthlyByMonth: action.payload };
    case "SET_ONE_WAY_CALENDAR_PRICES":
      return { ...state, oneWayCalendarPrices: action.payload };
    case "SET_MULTI_FLIGHTS":
      return { ...state, multiFlights: action.payload };
    case "ADD_MULTI_FLIGHT":
      // Maksimum 3 uçuş kontrolü
      if (state.multiFlights.length >= 3) {
        return state;
      }
      const lastFlight = state.multiFlights[state.multiFlights.length - 1];
      const newFlight = {
        id: Date.now(), // Unique ID
        departureCity: lastFlight.arrivalCity, // Önceki uçuşun varış yeri
        arrivalCity: null,
        departureDate: lastFlight.departureDate, // Önceki uçuşla aynı tarih
      };
      return {
        ...state,
        multiFlights: [...state.multiFlights, newFlight],
      };
    case "REMOVE_MULTI_FLIGHT":
      // Minimum 2 uçuş olmalı
      if (state.multiFlights.length <= 2) {
        return state;
      }
      return {
        ...state,
        multiFlights: state.multiFlights.filter(
          (flight) => flight.id !== action.payload,
        ),
      };
    case "UPDATE_MULTI_FLIGHT":
      const { flightId, field, value } = action.payload;
      const updatedFlights = state.multiFlights.map((flight) => {
        if (flight.id === flightId) {
          return { ...flight, [field]: value };
        }
        return flight;
      });

      // Eğer tarih güncelleniyorsa, sonraki uçuşların tarihlerini kontrol et
      if (field === "departureDate") {
        const flightIndex = updatedFlights.findIndex((f) => f.id === flightId);
        const selectedDate = new Date(value);

        for (let i = flightIndex + 1; i < updatedFlights.length; i++) {
          const currentFlightDate = new Date(updatedFlights[i].departureDate);
          if (currentFlightDate < selectedDate) {
            updatedFlights[i].departureDate = new Date(selectedDate);
          }
        }
      }

      return {
        ...state,
        multiFlights: updatedFlights,
      };
    case "TOGGLE_MULTI_FLIGHT_CITIES":
      const flightToToggle = state.multiFlights.find(
        (flight) => flight.id === action.payload,
      );
      if (!flightToToggle) return state;

      return {
        ...state,
        multiFlights: state.multiFlights.map((flight) => {
          if (flight.id === action.payload) {
            return {
              ...flight,
              departureCity: flight.arrivalCity,
              arrivalCity: flight.departureCity,
            };
          }
          return flight;
        }),
      };
    case "SET_PUBLIC_HOLIDAYS":
      return { ...state, publicHolidays: action.payload };
    default:
      return state;
  }
};

export default flightSearchReducer;
